import React from 'react';

class Checkbox extends React.Component {
    static defaultProps = {
        negate: false
    };

    onChange = ({ target }) => {
        const { field, model, negate } = this.props;
        const value = negate ? !target.checked : target.checked;
        this.props.onChange({ ...model, [field]: value ? '1' : '0' });
    };

    render() {
        const { field, model, negate, ...props } = this.props;
        const value = negate ? model[field] === '0' : model[field] === '1';

        return (
            <input
                type="checkbox"
                {...props}
                checked={value}
                onChange={this.onChange}
            />
        );
    }
}

export default Checkbox;



// WEBPACK FOOTER //
// ./src/pages/Relay/Checkbox.js